import React, { ReactElement, ReactNode } from 'react';
import classnames from 'classnames';
import useStyles from './styles';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import { useSideBarOpened } from '../../hooks/context/useSideBarOpened.hook';

interface ILayoutProps {
  children: ReactNode
}

function Layout({ children }: ILayoutProps): ReactElement {
  const classes = useStyles();
  const [isSidebarOpened] = useSideBarOpened();

  return (
    <div className={classes.root}>
      <>
        <Header />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: isSidebarOpened,
          })}
        >
          <div className={classes.topPadding} />
          {children}
        </div>
      </>
    </div>
  );
}

export default Layout;
